<template>
    <section class="category-header">
        <div class="container-fluid">
            <div class="category-title">
                <h1>{{ description ? description.header : 'Каталог' }}</h1>
                <span v-if="pagination.total && isReady">{{ pagination.total }} модели</span>
                <div class="category-sort dropdown d-sm-flex">
                    Сортировка
                    <button @click.prevent="showSort = !showSort" class="dropdown-toggle">
                        {{ selectedSortOption.label }}&nbsp;<i v-if="selectedSortOption.icon"
                                                               :class="selectedSortOption.icon"></i>
                    </button>
                    <div v-if="showSort" class="dropdown-menu">
                        <a v-for="({ label, icon }, index) in sortOptions" class="dropdown-item"
                           @click.prevent="setSorting(index)">
                            {{ label }}
                            <q-icon :name="icon" />
                        </a>
                    </div>
                </div>
            </div>
            <div class="category-filters category-filters--desktop" :class="{ expanded: isExpanded }">
                <div class="category-filters-wrap">
                    <div v-for="filter in filterList"
                         v-if="hasFilterValues(filter.slug) && !mustBeSkipped(filter.slug)"
                         class="filter"
                         :class="{ active: hasSelected(filter.slug), show: isActive(filter.slug)  }"
                         :id="'filter-' + filter.slug"
                         :style="!showFilter(filter.show_by_default) ? 'display:none;' : ''">

                        <button class="filter-toggle" :id="'filter-' + filter.slug"
                                type="button"
                                aria-haspopup="true"
                                :aria-expanded="isActive(filter.slug)"
                                :data-boundary="'filter-' + filter.slug"
                                @click.prevent="toggle(filter.slug)">
                            <span class="filter-name">{{ filter.name }}</span>
                            <span class="filter-count">
                                {{ selectedCount(filter.slug) }}
                            </span>
                            <span class="filter-arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="64px" height="64px"
                                 viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                                <polygon fill=""
                                         points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229 "></polygon>
                            </svg>
                            </span>
                            <span class="filter-clear" @click.prevent="clearFilterSelection(filter.slug)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px"
                                     viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                                    <path
                                        d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                                </svg>
                            </span>
                        </button>

                        <div class="filter-menu" v-show="isActive(filter.slug)"
                             :aria-labelledby="'filter-' + filter.slug">
                            <div v-if="!isSlider(filter.slug)" class="filter-menu-list">
                                <div v-for="(value, index) in filterValues(filter.slug)" class="filter-item">
                                    <div class="checkbox">
                                        <input :id="filter.slug + '-' + index" :name="filter.slug" type="checkbox"
                                               :value="{value: value.value, params: value.params}"
                                               v-model="optionValue" />
                                        <label :for="filter.slug + '-' + index">
                                            <a v-if="value.url" :href="value.url"
                                               @click.prevent="toggleOptionValue(value.value)">
                                                <span class="filter-item-title">{{ value.name }}</span>
                                                <span v-if="value.count" class="filter-item-count">{{
                                                        value.count
                                                    }}</span>
                                            </a>
                                            <span v-if="!value.url" class="filter-item-title">{{ value.name }}</span>
                                            <span v-if="!value.url && value.count"
                                                  class="filter-item-count">{{ value.count }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isSlider(filter.slug)">
                                <div class="filter-range">
                                    <input type="number"
                                           @keypress="onlyNumber($event)"
                                           :value="sliderValue(filter.slug)['min']"
                                           class="filter-range-control"
                                           @input="changeSliderValue(filter.slug, 'min', $event.target.value)" />
                                    <input type="number"
                                           @keypress="onlyNumber($event)"
                                           :value="sliderValue(filter.slug)['max']"
                                           class="filter-range-control"
                                           @input="changeSliderValue(filter.slug, 'max', $event.target.value)" />
                                </div>
                                <q-range :value="sliderValue(filter.slug)"
                                         @input="sliderValue(filter.slug, $event)"
                                         :min="rangeValue(filter.slug, 'min')"
                                         :max="rangeValue(filter.slug, 'max')"
                                         :step="interval(filter.slug)"
                                         :disable="rangeValue(filter.slug, 'min') === rangeValue(filter.slug, 'max')"
                                         label/>
                            </div>
                            <button class="filter-apply" :disabled="!changed && !isSliderChanged" type="button"
                                    @click="applyChanges">Применить
                            </button>
                        </div>
                    </div>
                </div>

                <a v-if="!isExpanded" class="all-filters" role="button" @click.prevent="toggleExpand()">
                    <span>Все фильтры</span>
                    <svg xmlns="http://www.w3.org/2000/svg"
                         x="0px" y="0px" width="64px" height="64px"
                         viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                        <polygon fill=""
                                 points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229 "></polygon>
                    </svg>
                </a>
            </div>
            <div class="category-filters category-filters--mobile">
                <q-btn label="категории" outline @click.prevent="toggleCategoryListMobile()"
                       style="margin-right: 10px;"/>
                <q-btn :label="'фильтры' + ' (' + totalSelected + ')'" outline
                       @click.prevent="openDialogFiltersMobile()"/>
            </div>
            <div v-if="categoriesListMobile" class="category-filters-list">
                <div v-if="parentCategory" class="filter">
                    <a @click.prevent="selectCategory(parentCategory)"
                       class="filter-toggle filter-toggle--more"
                       :href="'/catalog/' + parentCategory.slug">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enable-background="new 0 0 64 64">
                            <polygon fill="" points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229"></polygon>
                        </svg>{{ parentCategory.name }}</a>
                </div>
                <div class="filter" v-if="categoryId !== category.id" v-for="category in this.categories">
                    <a @click.prevent="selectCategory(category)"
                       class="filter-toggle"
                       :href="'/catalog/' + category.slug">{{ category.name }}</a>
                </div>
            </div>
        </div>
        <q-dialog v-model="dialogFiltersMobile" transition-show="slide-up" transition-hide="slide-down"
                  :maximized="maximizedToggle">
            <q-card class="modal-filters">
                <div class="modal-header">
                    <span class="modal-title">Фильтры</span>
                    <div class="modal-close" @click="closeDialogFiltersMobile">
                                <span aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                         width="10px" height="10px" viewBox="0 0 10 10" xml:space="preserve">
                                        <path
                                            d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                                    </svg>
                                </span>
                    </div>
                </div>

                <q-card-section class="modal-content">
                    <div class="filter"
                         :class="{ active: hasSelected('sort'), show: isActive('sort')  }">
                        <button class="filter-toggle" id="'filter-sort'"
                                type="button"
                                aria-haspopup="true"
                                data-boundary="filter-sort">
                                    <span class="filter-name" @click.prevent="openDialogFilterMobile('sort')">
                                        Сортировка
                                        <span class="filter-count">{{ selectedSort() }}</span>
                                    </span>
                            <span class="filter-clear" @click.stop="setSortOption(-1)">сбросить</span>
                        </button>
                    </div>
                    <div v-for="filter in filterList"
                         v-if="hasFilterValues(filter.slug)"
                         class="filter"
                         :class="{ active: hasSelected(filter.slug), show: isActive(filter.slug)  }"
                         :id="'filter-' + filter.slug">
                        <button class="filter-toggle" :id="'filter-' + filter.slug"
                                type="button"
                                :data-boundary="'filter-' + filter.slug">
                                    <span class="filter-name" @click.prevent="openDialogFilterMobile(filter.slug)">
                                        {{ filter.name }}
                                        <span class="filter-count">{{ selectedFilters(filter.slug) }}</span>
                                    </span>
                            <span class="filter-clear" @click.prevent="clearFilterSelection(filter.slug)">сбросить</span>
                        </button>
                    </div>
                    <q-dialog v-model="dialogFilterMobile"
                              transition-show="slide-up"
                              transition-hide="slide-down"
                              :maximized="maximizedToggle">
                        <q-card class="modal-filters">
                            <div class="modal-header" @click="closeDialogFilterMobile(active)">
                                        <span class="modal-arrow">
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                 x="0px" y="0px" width="64px"
                                                 height="64px" viewBox="0 0 64 64">
                                                <polygon points="36.238,44.061 24.271,32.226 36.156,20.115 37.996,21.918 27.907,32.199 38.05,42.229 "></polygon>
                                            </svg>
                                        </span>
                                <span class="modal-title">{{
                                        active === "sort" ? "Сортировка" : selectedFilterMobileTitle
                                    }}</span>
                            </div>
                            <q-card-section class="modal-content">
                                <div class="filter" v-if="isActive('sort')">
                                    <div class="filter-menu" aria-labelledby="filter-sort">
                                        <div class="filter-menu-list">
                                            <div v-for="({ label, sort, dir, icon }, index) in sortOptions"
                                                 class="filter-item">
                                                <div class="checkbox" @click.prevent="setSortOption(index)">
                                                    <input :id="'sort-' + index" name="sort" type="radio"
                                                           :value="{ sort: sort, dir: dir }"
                                                           :checked="selected.sort === sort && selected.dir === dir">
                                                    <label :for="'sort-' + index">
                                                        <span class="filter-item-title">{{ label }}</span>
                                                        <q-icon v-if="icon" :name="icon" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-for="filter in selectedFilterMobile"
                                     v-if="hasFilterValues(filter.slug)"
                                     class="filter"
                                     :class="{ active: hasSelected(filter.slug) }"
                                     :id="'filter-' + filter.slug">

                                    <div class="filter-menu" v-if="isActive(filter.slug)"
                                         :aria-labelledby="'filter-' + filter.slug">
                                        <div v-if="!isSlider(filter.slug)" class="filter-menu-list">
                                            <div v-for="(value, index) in filterValues(filter.slug)"
                                                 class="filter-item">
                                                <div class="checkbox">
                                                    <input :id="filter.slug + '-' + index"
                                                           :name="filter.slug + '[]'" type="checkbox"
                                                           :value="{value: value.value, params: value.params}"
                                                           v-model="optionValue">
                                                    <label :for="filter.slug + '-' + index">
                                                        <a v-if="value.url" :href="value.url"
                                                           @click.prevent="toggleOptionValue(value.value)">
                                                                    <span class="filter-item-title">{{
                                                                            value.name
                                                                        }}</span>
                                                            <span v-if="value.count" class="filter-item-count">{{
                                                                    value.count
                                                                }}</span>
                                                        </a>
                                                        <span v-if="!value.url"
                                                              class="filter-item-title">{{ value.name }}</span>
                                                        <span v-if="!value.url && value.count"
                                                              class="filter-item-count">{{ value.count }}</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isSlider(filter.slug)" class="filter-range-wrapper">

                                            <div class="filter-range">
                                                <input type="text"
                                                       @keypress="onlyNumber($event)"
                                                       :value="sliderValue(filter.slug)['min']"
                                                       class="filter-range-control"
                                                       @change="changeSliderValue(filter.slug, 'min', $event.target.value)">
                                                <input type="text"
                                                       @keypress="onlyNumber($event)"
                                                       :value="sliderValue(filter.slug)['max']"
                                                       class="filter-range-control"
                                                       @change="changeSliderValue(filter.slug, 'max', $event.target.value)">
                                            </div>

                                            <q-range :value="sliderValue(filter.slug)"
                                                     @input="sliderValue(filter.slug, $event)"
                                                     :min="rangeValue(filter.slug, 'min')"
                                                     :max="rangeValue(filter.slug, 'max')"
                                                     :step="interval(filter.slug)"
                                                     label/>
                                        </div>
                                    </div>
                                </div>
                            </q-card-section>
                            <q-card-actions class="q-pa-md">
                                <div class="col-6 pr-2">
                                    <q-btn label="Отменить" outline
                                           @click.prevent="clearFilterSelection(active)" v-close-popup
                                           class="full-width"/>
                                </div>
                                <div class="col-6 pl-2">
                                    <q-btn label="Применить" outline v-close-popup class="full-width"/>
                                </div>
                            </q-card-actions>
                        </q-card>
                    </q-dialog>
                </q-card-section>

                <q-card-actions class="q-pa-md">
                    <div class="col-6 pr-2">
                        <q-btn label="Отменить" outline class="full-width" v-close-popup
                               @click="clearAllFilterSelection"/>
                    </div>
                    <div class="col-6 pl-2">
                        <q-btn label="Показать" color="primary" v-close-popup @click="applyChanges"
                               class="full-width"/>
                    </div>
                </q-card-actions>
            </q-card>
        </q-dialog>
    </section>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';

export default {
    name: 'CatalogFilters',
    data() {
        return {
            showSort: false,
            active: null,
            isSliderChanged: false,
            isExpanded: false,
            categoriesListMobile: false,
            dialogFiltersMobile: false,
            dialogFilterMobile: false,
            maximizedToggle: true,
            totalSelected: 0,
            selectedFilterMobile: [],
            selectedFilterMobileTitle: "",
        }
    },
    mounted() {
        let _this = this;

        _this.totalSelected = _this.allSelectedCount();

        document.addEventListener('click', (e) => {
            if (!e.target.classList.contains('dropdown-toggle')) {
                _this.showSort = false;
            }
        });
        this.isExpanded = _.filter(this.filterList, filter => !filter.show_by_default).length === 0;
    },
    watch: {
        active(active) {
            if (active && window.width() > 991) {
                document.addEventListener('click', this.clickOutsideOfFilter);
            }
        },
        isReady(value) {
            if (value) {
                this.totalSelected = this.allSelectedCount();
            }
        },
    },
    computed: {
        ...mapState('catalog', [
            'pagination',
            'selected',
            'sortOptions',
            'description',
            'rangeFilters',
            'categoryId',
            'filterList',
            'activeSelected'
        ]),
        ...mapGetters('catalog', [
            'selectedCategory',
            'isReady',
            'selectedSortOption',
            'changed',
            'filterValues',
            'hasFilterValues',
            'mustBeSkipped',
        ]),
        optionValue: {
            get() {
                return this.selected[this.active]
                    ? this.selected[this.active]
                    : [];
            },
            set(value) {
                if (_.isEmpty(value)) {
                    Vue.delete(this.selected, this.active);
                } else {
                    Vue.set(this.selected, this.active, value);
                }
            }
        },
        categories() {
            if (this.selectedCategory) {
                if (this.selectedCategory.subCategories.length) {
                    return this.selectedCategory.subCategories;
                }
                return [this.selectedCategory];
            }

            let categories = this.$store.state.catalog.categories;
            return categories.length === 1 && categories[0].subCategories.length ? categories[0].subCategories : categories;
        },
        parentCategory() {
            if (this.selectedCategory && !_.isEmpty(this.selectedCategory.parent)) {
                return this.selectedCategory.parent;
            }
            return false;
        }
    },
    methods: {
        ...mapActions('catalog', [
            'applyFilters',
            'clearFilterSelection',
            'clearAllFilterSelection',
            'setSorting',
            'setCategoryId',
        ]),
        ...mapMutations('catalog', [
            'setSortOption',
        ]),
        openDialogFiltersMobile() {
            this.dialogFiltersMobile = true;
        },
        closeDialogFiltersMobile() {
            this.dialogFiltersMobile = false;

            this.clearAllFilterSelection();
        },
        toggleCategoryListMobile() {
            this.categoriesListMobile = !this.categoriesListMobile;
        },
        openDialogFilterMobile(filter) {
            this.active = filter;

            if (!(filter === 'sort')) {
                this.selectedFilterMobile = _.filter(this.filterList, function (f) {
                    if (f.slug === filter) {
                        return true;
                    }
                });
                this.selectedFilterMobileTitle = this.selectedFilterMobile[0]["name"]
            }
            this.dialogFilterMobile = true;
        },
        closeDialogFilterMobile() {
            this.clearFilterSelection(this.active);
            this.dialogFilterMobile = false;
        },
        toggle(filter) {
            if (this.isReady) {
                this.active = this.active === filter ? null : filter;
            } else {
                this.active = null;
            }
        },
        toggleExpand() {
            this.isExpanded = !this.isExpanded;
        },
        showFilter(value) {
            return value || this.isExpanded;
        },
        applyChanges() {
            this.toggle(null);
            this.applyFilters();
        },
        isActive(filter) {
            return filter === this.active;
        },
        clickOutsideOfFilter(event) {
            if (!this.isSliderChanged
                && !event.target.closest('.filter')
                && !event.target.classList.contains('filter-apply')
            ) {
                this.active = null;
            }
            this.isSliderChanged = false;
        },
        hasSelected(filter) {
            return this.selected[filter] && !_.isEmpty(this.selected[filter]);
        },
        selectedFilters(filter) {
            let str = '';

            if (this.selected[filter]) {

                const fields = this.filterValues(filter);
                const selectedFilters = this.selected[filter];

                if (Array.isArray(selectedFilters)) {
                    str = [];
                    selectedFilters.forEach((el) => {
                        let res = _.find(fields, {'value': el.value ? el.value : _.toString(el)});

                        if (res) {
                            str.push(res.name);
                        }
                    });
                    str = str.join(', ');
                } else {
                    str = selectedFilters.min + " - " + selectedFilters.max
                }
            }

            return str;
        },
        selectedSort() {
            const dir = this.selected.dir
            const sort = this.selected.sort
            const res = _.find(this.sortOptions, {'sort': sort, 'dir': dir})
            if (res) return res.label;
        },
        selectedCount(filter) {

            if (this.selected[filter] && !['dir', 'code', 'page'].includes(filter)) {
                return this.isSlider(filter) || filter === 'sort'
                    ? 1
                    : this.selected[filter].length;
            }
            return 0;
        },
        allSelectedCount() {
            let count = 0;

            for (let prop in this.selected) {
                count += this.selectedCount(prop);
            }
            return count;
        },
        isSlider(filter) {
            return this.rangeFilters.indexOf(filter) !== -1;
        },
        interval(filter) {
            switch (filter) {
                case 'price':
                    return 100;
                    break;
                case 'heel_height':
                case 'bootleg_width':
                    return 0.5;
                    break;
                default:
                    return 1;
            }
        },
        changeSliderValue(slug, index, value) {
            let min = this.sliderValue(slug)['min'],
                max = this.sliderValue(slug)['max'];

            if (index === "min") {
                min = value
            }
            if (index === "max") {
                max = value
            }

            let newValue = {
                min, max
            }

            this.setSliderValue(slug, newValue);
        },
        rangeValue(filter, value) {
            return parseFloat(this.filterValues(filter)[value]);
        },
        getSliderValue(filter) {

            let min = parseFloat(this.rangeValue(filter, 'min')),
                max = parseFloat(this.rangeValue(filter, 'max'));

            if (this.selected[filter] && this.selected[filter]['min'] >= min) {
                min = parseFloat(this.selected[filter]['min']);
            }
            if (this.selected[filter] && this.selected[filter]['max'] <= max) {
                max = parseFloat(this.selected[filter]['max']);
            }

            return {'min': min, 'max': max};
        },
        sliderValue(slug, value = null) {
            if (value) {
                this.setSliderValue(slug, value);
            } else {
                let value = this.getSliderValue(slug);

                if (!value) {
                    value = {
                        min: 0,
                        max: 0,
                    }
                }
                return value;
            }
        },
        setSliderValue(filter, value) {
            let min = value['min'],
                max = value['max'],
                minRangeValue = this.rangeValue(filter, 'min'),
                maxRangeValue = this.rangeValue(filter, 'max');

            if (min < minRangeValue) {
                min = minRangeValue;
            }

            if (max > maxRangeValue) {
                max = maxRangeValue;
            }

            if (min > max) {
                min = max;
            }

            this.$set(this.selected, filter, {min: min, max: max});

            if (min === minRangeValue && max === maxRangeValue) {
                this.$delete(this.selected, filter);
            }

            this.isSliderChanged = true;
        },
        toggleOptionValue(value) {
            let optionValue = this.optionValue;

            let index = optionValue.indexOf(value);

            if (index !== -1) {
                optionValue.splice(index, 1);
            } else {
                optionValue.push(value);
            }

            this.optionValue = optionValue;
        },
        selectCategory(category) {
            this.categoriesListMobile = false;

            if (parseInt(this.$root.gender) === parseInt(category.gender)) {
                this.setCategoryId(category.id);
                this.dialogCategoriesMobile = false;
            } else {
                let url = this.basePath + category.slug + '/';
                if (this.stock) {
                    url += '?code=' + this.stock.code;
                }
                window.location.href = url;
            }
        },
        onlyNumber(e) {
            e = (e) ? e : window.event;
            let charCode = (e.which) ? e.which : e.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                e.preventDefault();
            } else {
                return true;
            }
        }
    }
}
</script>

